import React, { Component } from 'react';

//Reactstrap
import { Container, Row, Col,
  CardImg, CardBody, CardTitle, CardSubtitle, CardText, Button
} from 'reactstrap';

//ReactDom
import { Link } from 'react-router-dom';
//style
import './SectionProductos.scss';

//imagenes
import img1 from './Imagen/Mesa-Portaprent.png';
import img2 from './Imagen/Mesa-Doble-.png';
import img3 from './Imagen/Mesa-Centro-.png';

class SectionProductos extends Component {
  constructor(props){
    super(props);
    this.state = {
       productos: 'productos-'
    }
  }
  
  componentDidCatch() {
    window.onscroll = () => {
      if (window.scrollY > 250)
        this.setState( prevState => {
          return{productos: 'productos'}
        })
      else{
        this.setState(prevState => {
          return{productos: 'productos-'}
        })
      }
    };
  }
  render() {
    return (
      <div className={"divcontinar"}>
        <h1 className={ `Section-Productos ${this.state.productos}`}>Conoce Nuestros <Link className={"LinkProductos"} to="/Productos"> Productos </Link></h1>
        <Container>
          <Row>
            <Col className={"Producto1"}  lg="4" md="4" sm="12" xs="12">
              <CardImg src={img3} />
              <CardBody>
                <CardTitle>Mesa centro</CardTitle>
                <CardSubtitle>Mesa Centro con diseños innovadores y tu gusto con diferentes funcionalidades.</CardSubtitle>
                <CardText></CardText>
                <Button color="secundary">Cotizar</Button>
              </CardBody>
            </Col>
            <Col className={"Producto2"} lg="4" md="4" sm="12" xs="12">
              <CardImg src={img2} />
              <CardBody>
                <CardTitle>Mesa Doble</CardTitle>
                <CardSubtitle>Mesa de atención la cual cuenta con una almacenamiento de productos más amplios</CardSubtitle>
                <CardText></CardText>
                <Button color="secundary">Cotizar</Button>
              </CardBody>
            </Col>
            <Col className={"Producto3"} lg="4" md="4" sm="12" xs="12">
              <CardImg src={img1} />
              <CardBody>
                <CardTitle>Mesa XM2</CardTitle>
                <CardText>Mesa de atención, facil de transportar y armar en la cual podrás mostrar tus producto.</CardText>
                <Button color="secundary" >Cotizar</Button>
              </CardBody>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default SectionProductos;



// WEBPACK FOOTER //
// ./src/Components/Section-Productos/SectionProductos.jsx